import Axios from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  fetchAnnouncementaudioAudioFailure,fetchAnnouncementaudioAudioSuccess
} from "../actions/announcementAudio.action";
import * as selectors from './selector';

 
//worker functions
function* workerFetchAnnouncementaudioAudio(action) {
  try {
    const moment = require('moment');
    const access_token = yield select(selectors.access_token);

    const resp = yield call(
      Axios.post, `${process.env.REACT_APP_BASE_URL}/ivrapi` + `${process.env.REACT_APP_ANNOUNCEMENTS_AUDIO_URL_PATH}`,
      { textToConvert: action.payload,
        audioEncodingScheme:"WAV" }, {
      headers: {
        Authorization: 'Bearer '+access_token,
        transactionId: 'CCCRC.' + moment().unix(),
        requestTimeStamp: moment.utc().toJSON(),
      }
    });
    yield put(fetchAnnouncementaudioAudioSuccess("data:audio/wav;base64," + resp.data.data));
  } catch (e) {
    yield put(fetchAnnouncementaudioAudioFailure(e.message));
  }
}

export function* watchFetchAnnouncementaudioAudio() {
  yield takeLatest("FETCH_ANNOUNCEMENT_AUDIO_START", workerFetchAnnouncementaudioAudio);
}

